import * as Types from 'declarations'
import { ACCENT_COLOUR } from 'pages/_app'

interface Props {
	trips: Types.DB.Models.TripAttributes[]
	alt: string
}

const CategoryPageTripRouteMap = ({ trips, alt }: Props) => {
	if (!trips) return <></>

	const locationCoords = trips.map((trip) => {
		const { latitude, longitude } = trip.jsonData.route?.locations?.[0] ?? {}

		return [longitude, latitude]
	})

	const jsonObject = {
		type: 'Feature',
		properties: {
			'marker-size': 's',
			'marker-color': ACCENT_COLOUR,
		},
		geometry: {
			type: 'MultiPoint',
			coordinates: locationCoords,
		},
	}
	const geojson = encodeURIComponent(JSON.stringify(jsonObject))

	const url = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/geojson(${geojson})/auto/1200x800?access_token=pk.eyJ1IjoiZzRmZDVnNGY1ZDRnNmQiLCJhIjoiY2tqY3dkNHNkMHlyMjMyc2NhMndqd29kOSJ9.8T_Vtjj5pL-wxSRv4IVuXA`
	const urlLen = url.length

	if (urlLen > 8192) {
		console.error('CUSTOM MAPBOX URL TOO LONG')
	}

	return (
		<div className="route-map-wrapper">
			<img src={url} alt={alt} title={alt} />
		</div>
	)
}

export default CategoryPageTripRouteMap
